import { createContext } from 'react';

export interface ToastContextType {
  toast: {
    isVisible: boolean;
    message: string;
  } | null;
  hideToast: () => void;
  showToast: (message: string) => void;
}

export const ToastContext = createContext<ToastContextType | null>(null);
